export const adaptKETOResumen = (data) => {
    const { ...ketosterilRI } = data?.ketosterilRI || {};
    const { __typename, ...laboratorioAdjunto } = data?.laboratorioAdjunto || {};
    return {
        ...ketosterilRI,
        laboratorioAdjuntoKETO: laboratorioAdjunto,
        idComboRIValorERCestadio: ketosterilRI.idComboRIValorERCestadioNavigation?.valor,
        laboratorioKETO: ketosterilRI.laboratorio,
    }
}